import { stdObject } from "../../../../data/types/stdObject";

export const preCashTotalFunc = (salesSection: stdObject) => {
  return "header" in salesSection
    ? salesSection.results.cash
        .filter((e: stdObject) => e.TYPE !== "COYP")
        .reduce((acc: number, curr: stdObject) => (acc += curr.TOT), 0)
    : 0;
};
